import { useContext, useMemo } from 'react';
import { ControlledDateTimePickerContext } from '../../ControlledDateTimePickerCTX.js';
import { getDayFromDateString } from '../dateHelpers.js';

export const useGetDayFromDateString = (): Date | null => {
  const { dateStringFromProps } = useContext(ControlledDateTimePickerContext);
  return useMemo(() => getDayFromDateString(dateStringFromProps), [dateStringFromProps]);
};
